import { render, staticRenderFns } from "./size-table.vue?vue&type=template&id=1bfd32a1&"
import script from "./size-table.vue?vue&type=script&lang=js&"
export * from "./size-table.vue?vue&type=script&lang=js&"
import style0 from "./size-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bfd32a1')) {
      api.createRecord('1bfd32a1', component.options)
    } else {
      api.reload('1bfd32a1', component.options)
    }
    module.hot.accept("./size-table.vue?vue&type=template&id=1bfd32a1&", function () {
      api.rerender('1bfd32a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/size-table.vue"
export default component.exports